import get from "lodash/get";
import maxBy from "lodash/maxBy";
import reduce from "lodash/reduce";

import {WaterfallRow, WFItem} from "@/components/transaction/WaterfallRow.tsx";
// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter.js";

export const RequestsWaterfall = ({requests}: {requests: unknown[]}) => {
  if (!requests || requests.length === 0) {
    return null;
  }
  const firstRequest = requests[0];
  const T0 = get(firstRequest, "timing.requestWillBeSent");

  // calculate waterfall timings adjusting 0 time to first request and converting everything to milliseconds
  let waterfall = requests.map((r) => {
    if (get(r, "timing.loadingFinished") !== null) {
      // @ts-expect-error legacy
      const start = r.timing.requestWillBeSent - T0,
        // @ts-expect-error legacy
        requestEnd = start + r.timing.sendEnd,
        // @ts-expect-error legacy
        responseStart = start + r.timing.receiveHeadersEnd,
        // @ts-expect-error legacy
        responseEnd = r.fromCache ? responseStart : r.timing.loadingFinished - T0;
      return {
        //escape html and special chars in url
        // @ts-expect-error legacy
        url: r.url.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"),
        // @ts-expect-error legacy
        status: r.status,
        // @ts-expect-error legacy
        resourceType: r.resourceType,
        // @ts-expect-error legacy
        size: r.size,
        // absolute values
        requestStart: start,
        requestEnd: requestEnd,
        responseStart: responseStart,
        responseEnd: responseEnd,
        // durations
        // @ts-expect-error legacy
        sendingRequest: r.timing.sendEnd,
        // @ts-expect-error legacy
        dns: r.timing.dnsEnd - r.timing.dnsStart,
        // @ts-expect-error legacy
        connect: r.timing.connectEnd - r.timing.connectStart,
        // @ts-expect-error legacy
        connectSecureConnection: r.timing.sslEnd - r.timing.sslStart,
        // @ts-expect-error legacy
        requestSending: r.timing.sendEnd - r.timing.sendStart,
        waitingResponse: responseStart - requestEnd,
        downloadingData: responseEnd - responseStart,
        duration: responseEnd - start,
      };
    } else {
      const url = get(r, "url") || "";
      const requestWillBeSent = get(r, "timing.requestWillBeSent");
      return {
        url: url.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"),
        status: null,
        resourceType: null,
        size: null,
        requestStart: requestWillBeSent && T0 ? requestWillBeSent - T0 : 0,
        requestEnd: null,
        responseStart: null,
        responseEnd: null,
        sendingRequest: null,
        dns: null,
        connect: null,
        connectSecureConnection: null,
        requestSending: null,
        waitingResponse: null,
        downloadingData: null,
        duration: null,
      };
    }
  });

  const latest = maxBy(waterfall, (x) => x.responseEnd);
  const total_duration = latest?.responseEnd || 1000; // if not any request finished, set total duration to 1s
  const ms_pct = 100 / total_duration;
  const total_size = reduce(
    waterfall,
    function (memo, x) {
      return memo + x.size;
    },
    0
  );

  //calculate pixel percent data for display
  waterfall = waterfall.map((wf) => {
    return {
      ...wf,
      pct: {
        requestStart: wf.requestStart * ms_pct,
        // for unfinished requests, set duration to 100ms so that they are visible in waterfall
        requestDuration: wf.requestEnd !== null ? (wf.requestEnd - wf.requestStart) * ms_pct : 100 * ms_pct,
        waitStart: wf.requestEnd * ms_pct,
        waitDuration: (wf.responseStart - wf.requestEnd) * ms_pct,
        receiveStart: wf.responseStart * ms_pct,
        receiveDuration: (wf.responseEnd - wf.responseStart) * ms_pct,
      },
    };
  });

  //ticks
  const ticks_num = 7;
  const wf_ticks = [];
  for (let i = 0; i < ticks_num; i++) {
    wf_ticks.push({
      left: (100 / ticks_num) * i,
      val: Formatter.autoDuration((total_duration / 1000 / ticks_num) * i),
    });
  }

  const ticks = wf_ticks.map((t) => (
    <span className="wf-tick" style={{left: `${t.left}%`}}>
      {t.val}
    </span>
  ));

  const url =
    "https://support.uptime.com/hc/en-us/articles/360000984785-Synthetic" +
    "-Monitoring-With-the-Uptime-com-Transaction-Check#data-on-check-failure";
  return (
    <div>
      <p>
        <a href={url} target="_blank">
          View Documentation
        </a>
      </p>
      <div className="requestsWaterfall table-responsive">
        <table className="table listing-table table-valign-middle">
          <thead>
            <tr>
              <th>URL</th>
              <th>Status</th>
              <th>Type</th>
              <th>Size</th>
              <th>Duration</th>
              <th className="wf-tick-cell">{ticks}</th>
            </tr>
          </thead>
          <tbody>
            {waterfall.map((item: unknown) => (
              <WaterfallRow wf={item as WFItem} />
            ))}
          </tbody>
          <tfoot>
            <tr className="fw-semibold">
              <td>Total requests: {requests.length}</td>
              <td></td>
              <td></td>
              <td>{Formatter.humanBytes(total_size || 0)}</td>
              <td>{Formatter.ms(total_duration)}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
